module.exports = __webpack_public_path__ + "static/media/lv.4e43b4fe.webp";